import Vue from 'vue'
// import router from './router'
import VueAnalytics from 'vue-analytics'

Vue.use(VueAnalytics, {
    id: 'UA-172048585-1',
    // router,
    autoTracking: {
        exception: true
    }
})